<!--
 * @Description: 查看课件
 * @Author: 王赵坤
 * @Date: 2023-02-21 10:21:17
 * @LastEditors: PF
 * @LastEditTime: 2024-08-02 11:44:42
-->
<template>
  <div>
    <el-dialog class="w850 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">查看课件</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="140px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="课程" label-align="right" align="left" width="100px" span="2">{{ruleForm.kcmc}}</el-descriptions-item>
        <el-descriptions-item label="周次" label-align="right" align="left" span="2">第{{ruleForm.zc}}周</el-descriptions-item>
        <el-descriptions-item label="状态" label-align="right" align="left" span="2"><span v-if="ruleForm.zt">{{ruleForm.zt.name}}</span></el-descriptions-item>
        <el-descriptions-item label="班级/节次 " label-align="right" align="left" span="4">
          <span>{{ruleForm.bjmc}} / 星期{{week[ruleForm.xq]}} 第{{ruleForm.jc}}节</span>
        </el-descriptions-item>
        <el-descriptions-item label="教学单元" label-align="right" align="left" width="140px" span="2">{{ruleForm.jxdybt}}</el-descriptions-item>
        <el-descriptions-item label="教学内容" label-align="right" align="left" width="140px" span="2">{{ruleForm.jxnrbt}}</el-descriptions-item>
        <el-descriptions-item label="视频" label-align="right" align="left" width="140px" span="4">
          <span v-if="fjSps.length" style="color: #409EFF;cursor: pointer;" @click="openFuJian=true;tcrow={listFj:fjSps||[]}">预览</span>
        </el-descriptions-item>
        <el-descriptions-item label="附件" label-align="right" align="left" width="140px" span="4">
          <span v-if="fjPdfs.length" style="color: #409EFF;cursor: pointer;" @click="openFuJian=true;tcrow={listFj:fjPdfs||[]}">预览</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
  <fujian v-if="openFuJian" v-model:openDetail="openFuJian" :row="tcrow" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { warningPrompt } from '@/utils/promptInfo'
import { closeWindow, actionPost } from '@/api/common.js'
import fujian from '@/components/fujian.vue'

const emits = defineEmits(['update:openDetail', 'ReturnData'])
const props = defineProps({
  openDetail: {
    type: Boolean,
    required: true
  },
  row: {
    type: Object,
    required: false
  },
  chechboxtrue: {
    type: Array,
    required: false
  }
})
const tcrow = ref()
const openFuJian = ref(false)
const ruleForm = ref({})

const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])
const fjSps = ref([])
const fjPdfs = ref([])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      actionPost({ url: '/api/v2/jiaowu/jiaowukejian/' + props.row.kjid, data: {} }).then(res => {
        if (res.code === 200) {
          ruleForm.value = res.data
          fjSps.value = res.data.listShiPin ? res.data.listShiPin.map(item => ({ fj: item.fj, ymc: item.ymc })) : []
          fjPdfs.value = res.data.listFuJian ? res.data.listFuJian.map(item => ({ fj: item.fj, ymc: item.ymc })) : []
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
